export default {
  industryTypes:[]
}
